export default class Access {
  constructor(configAccess) {
    if (!configAccess) {
      this.setLevel(0)
    } else if (typeof configAccess === 'number') {
      this.setLevel(configAccess)
    } else {
      this.setLevel(configAccess.level)
    }
  }

  has(access) {
    if (access instanceof Access) {
      return access.accessLevel === 0 || (this.accessLevel > 0 && this.accessLevel <= access.accessLevel)
    }
    return access === 0 || (this.accessLevel > 0 && this.accessLevel <= access)
  }

  get level() {
    return this.accessLevel
  }

  setLevel(value) {
    this.accessLevel = Math.max(parseInt(value, 10) || 0, 0)

    this.admin = !!(this.accessLevel & 1)

    this.editor = !!(this.accessLevel & 2)

    this.viewer = !!(this.accessLevel & 2)
  }
}
